import React, { useState, useEffect, useRef } from 'react';
import styled from 'styled-components/macro';
import { logEvent } from 'utils/analytics';
import { PALETTE_NAMES } from '../constants';
import EulerBeatsWrapper from 'utils/EulerBeatsWrapper';

const Table = styled.table`
  color: #333;
`;

interface EnigmaVisualizationProps {
  seed: string;
  size?: string | number;
  isPrint?: boolean;
  showTraits?: boolean;
  onPlay?: (event:any) => void;
}

enum PlayState {
  start='start',
  stop="stop",
  end="end",
}

const EnigmaVisualization = ({
  seed,
  isPrint,
  showTraits,
  size = 480,
  onPlay,
}: EnigmaVisualizationProps) => {
  const playerEl = useRef(null);
  const elementId = `eulerbeats-${isPrint ? 'print' : 'original'}-${seed}`;
  const seedToRender = seed.startsWith('0x') ? seed : '0x' + seed;
  const [traits, setTraits] = useState<any>(null);

  useEffect(() => {
    const element = playerEl.current;

    const settings = {
      size,
    };

    try {
      if (element) {
        const enigmaTraits = window.EulerBeatsEnigma.visual.render(element, seedToRender, settings, (elementId: string, event: PlayState) => {
          if (onPlay) {
            onPlay(event);
          } else {
            const toggleElement = document.getElementById(`${elementId}-toggle`);
            if (toggleElement) {
              if (event === 'start') {
                toggleElement.classList.add('is-playing');
              } else if (event === 'stop') {
                toggleElement.classList.remove('is-playing');
              }
            }
          }
        });
        setTraits(enigmaTraits);
      }
    } catch (error) {
      console.error('Error rendering item')
      console.error(error);
    } 

    return () => {
      EulerBeatsWrapper.visual.stop();
    };
  }, [
    size,
    seedToRender,
    onPlay,
  ]);

  const handleClick = () => {
    logEvent('click_visualization', {
      event_category: 'EulerBeat Interaction',
      event_label: 'Click on visualization',
      name: elementId,
    });
  }

  return (
    <>
      <div
        id={elementId}
        ref={playerEl}
        onClick={handleClick}
      />
      {
        showTraits && traits && (
          <Table>
            <thead>
              { Object.keys(traits).map(key => (
                <tr key={key}>
                  <td>
                    { key }
                  </td>
                  <td>
                    { key === 'paletteLever'
                        ? PALETTE_NAMES[traits[key]]
                        : traits[key]
                      }
                  </td>
                </tr>
              )) }
            </thead>
          </Table>
        )
      }
    </>
  );
};

export default EnigmaVisualization;
